// extracted by mini-css-extract-plugin
export default {"swatch":"q6DGbbH"};